import {PlatformComponentContext} from 'src/components/PlatformContext/types';
import {Loader} from 'src/components/Suspense';

const basicContext: PlatformComponentContext = {
  LaunchScreen: Loader,
};

export default basicContext;
